/* eslint-disable react/no-unescaped-entities */
import * as React from "react";
import { Avatar, Badge, Icon } from "antd";
// Local Components
import InfoRow from "./components/InfoRow";
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
// Shared components
import Button from "components/Button";
import Main from "./../../../../components/Main";
// Utilities and hooks
import { get } from "lodash";
import { inject, observer } from "mobx-react";
import UserStore from "state/user";
import { getBase64 } from "helpers/index";
// Styles
import styles from "./index.module.scss";
import moment from "moment-jalaali";
import GeneralService from "services/http/endpoints/general";

interface IProps {
	onSubmit?: (data: any) => void;
	user?: UserStore;
}

const UserInfo: React.FC<IProps> = props => {
	const user = props.user ? props.user.getUser : {};
	const [nationCardUrl, setNationCardUrl] = React.useState();
	const birthday = get(user, ["profile", "birthdayTimestamp"]);
	const nationCardId = get(user, ["profile", "nationCartImage", "id"]);

	React.useEffect(() => {
		if (nationCardId) getNationCardImage(nationCardId);
	}, [nationCardId]);

	const genderFormatted = (gender: string) => {
		switch (gender) {
			case "MAN":
				return "مرد";
			case "WOMAN":
				return "زن";
			default:
				return "-";
		}
	};

	const getNationCardImage = async (id: string) => {
		const response = await GeneralService.file(id);
		const blob = new Blob([response.data], {
			type: "image/jpeg",
		});
		getBase64(blob, (img: any) => setNationCardUrl(img));
	};

	const profileStatusFormatted = (): React.ReactNode => {
		switch (get(user, ["profile", "profileStatus"])) {
			case "NOT_COMPLETED":
				return <Icon type="exclamation-circle" className={styles["profile-status"]} />;
			case "COMPLETED_NOT_VERIFIED":
				return <Icon type="issues-close" className={styles["profile-status"]} style={{ color: "#faad14" }} />;
			case "VERIFIED":
				return <Icon type="check-circle" className={styles["profile-status"]} style={{ color: "#52c41a" }} />;
			case "REJECTED":
				return <Icon type="close-circle" className={styles["profile-status"]} style={{ color: "#f5222d" }} />;
			default:
				return <Icon type="loading" className={styles["profile-status"]} />;
		}
	};

	return (
		<Main title="اطلاعات حساب کاربری شما">
			<div className="card">
				<div className="text-center">
					<Badge count={profileStatusFormatted()}>
						<Avatar size="large" src={get(props.user, "profileImage")} />
					</Badge>
				</div>
				<div className={styles["info-list"]}>
					<InfoRow content={get(user, ["baazarCode"])} title="کد بازر" />
					<InfoRow content={get(user, ["profile", "firstname"])} title="نام" />
					<InfoRow content={get(user, ["profile", "lastname"])} title="نام خانوادگی" />
					<InfoRow content={genderFormatted(get(user, ["profile", "gender"]))} title="جنسیت" />
					<InfoRow content={get(user, ["profile", "nationCode"])} title="کد ملی" />
					<InfoRow content={birthday ? moment(birthday).format("jYYYY/jMM/jDD") : "-"} title="تاریخ تولد" />
					<InfoRow
						content={get(user, ["username"])}
						title={get(user, "usernameType") === "EMAIL" ? "ایمیل" : "شماره موبایل"}
					/>
					{get(user, "usernameType") === "EMAIL" && (
						<InfoRow content={get(user, ["profile", "mobile"])} title="شماره موبایل" />
					)}
					{nationCardId && (
						<>
							<InfoRow
								content={<Avatar shape="square" size="large" src={nationCardUrl} />}
								title="تصویر کارت ملی"
							/>
						</>
					)}
					<Button onClick={props.onSubmit} primary>
						ویرایش اطلاعات
					</Button>
				</div>
			</div>
		</Main>
	);
};
export default inject("user")(observer(UserInfo));
